import React, { useEffect, useMemo, useState, useContext } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import config from "../../../config/config";
import axios from "axios";
import CommonDatePickerSelect from "../../../components/DatePicker/CommonDatePickerSelect";
import Select from "react-select";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import { toastSuccess, toastWarn } from "../../../common/Toast";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import { Box } from "@mui/material";
import { AppContext } from "../../../context/AppContext";
import moment from "moment";

const DriverTaskList = () => {
   const { dateFormate } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [startDate, setStartdate] = useState("");
  const [endDate, setEnddate] = useState("");
  const [isRoutesdropdown, setRoutesdropdown] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState("");
  const [employeeid, setempolyee] = useState(0);
  const [usersDropdown, setUsersDropdown] = useState([]);
  const token = localStorage.getItem("Token");
  const ID = localStorage.getItem("ID");
  const location = localStorage.getItem("Location");

  const [deleteDriverTaskId, setDeleteDriverTaskId] = useState(0);

  const handleViewClick = (id) => {
    navigate(`/Driver-Task-Receipt/${id}`);
  };

  const handleDeleteClick = () => {
    if (deleteDriverTaskId == 0) {
      toastWarn("please Select Driver for delete");
      return;
    }
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/DriverTaskDelete`,
        { taskId: deleteDriverTaskId, loginUserId: ID },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            'Access-Control-Allow-Origin': "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode == "SUCCESS") {
          toastSuccess(res.data.ResponseMessage);
          driverfatchData();
          setDeleteDriverTaskId(0);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const uniqueRoutess = [...new Set(tableData?.map((item) => item.Routess))];
  let concatenatedRoutess = uniqueRoutess?.join(", ");

  const columns = useMemo(
    () => [
      {
        header: "TaskId",
        accessorKey: "ID",

        Cell: ({ row }) => <Box
        component="span"
        sx={(theme) => ({
          borderRadius: "0.3rem",
          color: "#343f62",
          maxWidth: "18ch",
          fontWeight: "700",
          textDecoration: "underline",
          textUnderlineOffset: "3px",
          p: "0.3rem",
          cursor: "pointer",
        })}
        onClick={() =>
          navigate(`/Driver-Task-Receipt/${row.original.ID}`, "_blank")
        }
      >
        {row.original.ID}
      </Box>,
        // size: 50,
      },
      {
        header: "Created Date",
        accessorKey: "CreatedDate",
        Cell: ({ row }) => moment(row.original.CreatedDate).format(`${dateFormate.toUpperCase()} hh:mm:ss a`),
        // size: 120,
      },
      {
        header: "Employee Name ",
        accessorKey: "employees",
        // size: 120,
        // filterFn: "contains",
      },
      {
        header: "Delivery Status",
        accessorKey: "DeliveryStatus",
        // size: 80,
      },
      {
        header: "Route",
        accessorKey: "Routess",
        // size: 80,
      },
      {
        header: "REP",
        accessorKey: "REPs",
        // size: 80,
      },
      {
        header: "Invoice Count",
        accessorKey: "InvoiceCount",
        // size: 50,
      },
      {
        header: "Action", // Custom column for the view button
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              onClick={() => handleViewClick(row.original.ID)} // Handle the click event
              style={{
                backgroundColor: "#1b2850",
                color: "white",
                border: "none",
                padding: "5px 10px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              View
            </button>
            <button
              onClick={() => setDeleteDriverTaskId(row.original.ID)} // Handle the click event
              style={{
                backgroundColor: "#1b2850",
                color: "white",
                border: "none",
                padding: "5px 10px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              data-bs-target="#ConfirmModal"
              data-bs-toggle="modal"
            >
              Delete
            </button>
          </div>
        ),
        // size: 100,
      },
    ],
    []
  );

  const callbackStartDate = (startDate) => {
    setStartdate(startDate);
  };
  const callbackEndDate = (endDate) => {
    setEnddate(endDate);
  };

  useEffect(() => {
    axios
      .get(`${config.customersBaseUrl}/customers/Routesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          'Access-Control-Allow-Origin': "*",
          Authorization: token,
        },
      })
      .then((res) => setRoutesdropdown(res.data.ResponseData))
      .catch((error) => console.log(error));

    axios
      .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("usersdropdown", res);
        setUsersDropdown(res.data.ResponseData);
        // setLoading(false);

        return res;
      });
  }, []);

  const driverfatchData = () => {
    if (!startDate || !endDate) {
      return;
    }

    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/drivertasklist?locationid=${location}&startdate=${startDate}&endDate=${endDate}&selectedRoute=${selectedRoute}&employeeid=${employeeid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        setTableData(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    driverfatchData();
  }, [employeeid, selectedRoute, endDate, startDate]);

  let isRoutesdropdownOption = [];
  const categorytypeDropdown = isRoutesdropdown.map((u, i) => {
    isRoutesdropdownOption[i] = {
      label: u.RouteName,
      value: u.ID,
    };
  });

  let usersDropdownOption = [];
  const userDropdown = usersDropdown.map((u, i) => {
    usersDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Inventory: Items</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/Driver-Daily-sheet">Driver Daily Sheet</Link>
                </li>
                <li className="breadcrumb-item active">Driver task List </li>
              </ul>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  {" "}
                  Employee :
                  <Select
                    options={usersDropdownOption}
                    className="custom-search-select mt-1"
                    value={usersDropdownOption.find(
                      (el) => el.value === employeeid
                    )}
                    isClearable={true}
                    onChange={(event) =>
                      setempolyee(event?.value ? event?.value : 0)
                    }
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  />
                </div>

                <div className="col-md-3">
                  {" "}
                  Routes:
                  <Select
                    options={isRoutesdropdownOption}
                    className="custom-search-select mt-1"
                    value={isRoutesdropdownOption.find(
                      (el) => el.label === selectedRoute
                    )}
                    isClearable={true}
                    onChange={(event) =>
                      setSelectedRoute(event?.label ? event?.label : "")
                    }
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  />
                </div>
                <CommonDatePickerSelect
                  callbackEndDate={callbackEndDate}
                  callbackStartDate={callbackStartDate}
                  dateSelectValue={9}
                />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              {/* custom-table-css */}
              <div
                className="table-responsive"
                style={{ position: "relative", zIndex: "0" }}
              >
                <CommonMatrialReactTable
                  MainHeading="Sonar POS"
                  ReportHeading="Inventory Print"
                  columns={columns}
                  data={tableData}
                  startdate={""}
                  enddate={""}
                  columnGrouping={[]}
                  columnsVisibility={{}}
                  isdrivertasklist={true}
                  enableRowSelection={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmModal
        handleSubmit={handleDeleteClick}
        text="Are you sure you want to Delete Driver Task"
      />
    </>
  );
};

export default DriverTaskList;
